import { render, staticRenderFns } from "./coreSkills.vue?vue&type=template&id=bf517bf8&"
import script from "./coreSkills.vue?vue&type=script&lang=js&"
export * from "./coreSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports